
/**
 * Module dependencies.
 */

import { Context, createContext, useContext } from 'react';

/**
 * Export `FormErrorsBasePathContext` context.
 */

export const FormErrorsBasePathContext: Context<string | null> = createContext<string | null>(null);

/**
 * Export `useFormErrorsBasePath` hook.
 */

export const useFormErrorsBasePath = () => useContext(FormErrorsBasePathContext);
